import flatpickr from 'flatpickr'
import { Romanian } from "flatpickr/dist/l10n/ro.js"

document.addEventListener('DOMContentLoaded', function () {
    const pickers = document.getElementsByClassName('js-date-picker')

    let config = {
        locale: Romanian,
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "d.m.Y",
    }

    Array.from(pickers).forEach((picker) => {
        if (picker.dataset.minDate) {
            config.minDate = picker.dataset.minDate
        }
        if (picker.dataset.maxDate) {
            config.maxDate = picker.dataset.maxDate
        }
        flatpickr(picker, config)
    })
})
